import React from 'react';
import { MapBoxView as BaseMapBoxView } from '@/components/composite/MapBoxView';
import { Styles } from '@/styles/styles';
import { useMapContext } from '../context/MapContextProvider';

const LEFT = Styles.baseLeftPanelWidth;
const WIDTH = `calc(100% - ${LEFT})`;
const POSITION = { width: WIDTH, left: LEFT, right: 0 };

const DEFAULT_POSITION = {
  width: '100%',
  right: 0,
};

export const MapBoxView = () => {
  const { mapRefEl, moveRight } = useMapContext();

  return (
    <BaseMapBoxView mapRefEl={mapRefEl} style={{ height: 'inherit', ...(moveRight ? POSITION : DEFAULT_POSITION) }} />
  );
};
